<template>
  <el-drawer v-loading="loading" class="form-wp" :visible="visible" size="75%" :wrapper-closable="false"
    :show-close="false" @close="close">
    <template slot="title">
      <h2>{{ action === 'new' ? '新增' : '编辑' }}角色</h2>
      <div>
        <el-button type="primary" @click="submit">确定</el-button>
        <el-button type="default" @click="close">取消</el-button>
      </div>
    </template>

    <el-form ref="form" :model="form" :rules="rules" label-width="140px" label-suffix="：">
      <el-form-item label="角色名称" prop="roleName">
        <el-input v-model="form.roleName" maxlength="20" placeholder="请输入角色名称" style="width: 320px" />
      </el-form-item>
      <el-form-item label="菜单权限" prop="menuIds">
        <el-radio-group v-model="platform" size="mini" @change="changePlat">
          <el-radio-button label="2">服务端</el-radio-button>
          <el-radio-button label="3">PDA端</el-radio-button>
        </el-radio-group>
        <div v-show="platform == 2" style="margin: 8px 0">
          <el-checkbox v-model="menuExpand2" @change="handleCheckedTreeExpand($event, '2')">展开/折叠</el-checkbox>
          <el-checkbox v-model="menuNodeAll3" @change="handleCheckedTreeNodeAll($event, '2')">全选/全不选</el-checkbox>
        </div>
        <div v-show="platform == 3" style="margin: 8px 0">
          <el-checkbox v-model="menuExpand2" @change="handleCheckedTreeExpand($event, '2')">展开/折叠</el-checkbox>
          <el-checkbox v-model="menuNodeAll3" @change="handleCheckedTreeNodeAll($event, '3')">全选/全不选</el-checkbox>
        </div>

        <el-tree v-show="platform == 2" ref="serverMenu" class="tree-border" :data="menuOptions2" show-checkbox
          node-key="id" :check-strictly="false" :props="defaultProps"></el-tree>
        <el-tree v-show="platform == 3" ref="pdaMenu" class="tree-border" :data="menuOptions3" show-checkbox node-key="id"
          :check-strictly="false" :props="defaultProps"></el-tree>
      </el-form-item>
    </el-form>
  </el-drawer>
</template>

<script>
import {
  addRole,
  updateRole,
  updateRolePrivate,
  addRolePrivate,
  getRole,
  getRolePrivate
} from '@/api/system/role.js'
import { treeselect, treeselectPrivate } from '@/api/system/menu.js'

const plat = {
  2: 'serverMenus',
  3: 'pdaMenus'
}

export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    action: { type: String, default: 'new' },
    data: { type: Object, default: () => { } }
  },
  data() {
    return {
      loading: false,
      platform: '2',
      form: {
        roleName: '',
        menuIds: [],
        roleId: ''
      },
      rules: {
        roleName: [{ required: true, message: '请填写角色名称', trigger: 'blur' }],
        menuIds: [{ required: true, message: '请选择菜单', trigger: 'blur' }]
      },
      menuCheckStrictly: false,
      deptCheckStrictly: '',
      menuExpand2: false,
      menuNodeAll2: false,
      menuExpand3: false,
      menuNodeAll3: false,
      deptExpand: true,
      allMenus: { pdaMenus: null, serverMenus: null },
      menuOptions2: [], // 服务端
      menuOptions3: [], // PDA
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      treeForm: {
        appId: '2'
      },
      flag: false
    }
  },

  created() {
    if (this.action === 'edit') {
      this.form = JSON.parse(JSON.stringify(this.data))
    } else {
      this.$nextTick(() => {
        this.$refs.serverMenu.setCheckedKeys([])
        this.$refs.pdaMenu.setCheckedKeys([])
      })

    }
    this.getTree()
  },

  methods: {
    // 不同部署方式查询菜单不一致，SAAS与PRIVATE
    async getTree() {
      this.getTreeSass()
    },

    // saas获取菜单树
    getTreeSass() {
      treeselect({ pdaAppId: '5', serverAppId: '4' })
        .then((res) => {
          const { data, code, msg } = res
          if (code === 200) {
            this.allMenus = data
            this.menuOptions2 = this.allMenus.serverMenus
            this.menuOptions3 = this.allMenus.pdaMenus
            if (this.form.roleId) {
              getRole(this.form.roleId).then((rsp) => {
                const { checkedKeys } = rsp.data
                const serverMenus = []
                const pdaMenus = []
                for (let index = 0; index < checkedKeys.length; index++) {
                  // 服务端菜单便利查找，如果当前层级不存在子级而菜单id存在则表示已选中，如果
                  this.flag = false
                  this.mapTree(this.menuOptions2, checkedKeys[index], checkedKeys)
                  if (this.flag) {
                    serverMenus.push(checkedKeys[index])
                  }
                }
                for (let index = 0; index < checkedKeys.length; index++) {
                  // 服务端菜单便利查找，如果当前层级不存在子级而菜单id存在则表示已选中，如果
                  this.flag = false
                  this.mapTree(this.menuOptions3, checkedKeys[index], checkedKeys)
                  if (this.flag) {
                    pdaMenus.push(checkedKeys[index])
                  }
                }
                this.$refs.serverMenu.setCheckedKeys(serverMenus)
                this.$refs.pdaMenu.setCheckedKeys(pdaMenus)
              })
            }
          } else {
            this.$message.error(msg)
          }
        })
        .catch((err) => {
          this.$message.error(err)
        })
    },

    // 便利树结构,data为菜单数据，menuId为菜单id，arr存当前menuId的所有子集是否存在
    mapTree(data, menuId, checkedKeys) {
      for (let index = 0; index < data.length; index++) {
        if (data[index].id == menuId) {
          if (data[index].children) {
            const array = []
            // 递归查找当前id下所有子节点，如果所有子节点都存在才能进行勾选
            this.getChildren(data[index].children, array)
            this.flag = array.every((item) => checkedKeys.includes(item))
          } else {
            this.flag = true
          }
          break
        } else if (data[index].children) {
          this.mapTree(data[index].children, menuId, checkedKeys)
        }
      }
    },
    getChildren(data, array) {
      if (data) {
        data.forEach((item) => {
          array.push(item.id)
          if (item.children) {
            this.getChildren(item.children, array)
          }
        })
      }
    },
    // 私有化获取菜单树
    getTreeselectPrivate() {
      treeselectPrivate({ privateName: process.env.VUE_APP_PRIVATE_NAME, appId: 100 })
        .then((res) => {
          const { data, code, msg } = res
          if (code === 200) {
            this.allMenus = data
            this.menuOptions2 = this.allMenus.serverMenus
            this.menuOptions3 = this.allMenus.pdaMenus
            if (this.form.roleId) {
              getRolePrivate({
                roleId: this.form.roleId,
                privateName: process.env.VUE_APP_PRIVATE_NAME
              }).then((rsp) => {
                const { checkedKeys } = rsp.data
                const serverMenus = []
                const pdaMenus = []
                for (let index = 0; index < checkedKeys.length; index++) {
                  // 服务端菜单便利查找，如果当前层级不存在子级而菜单id存在则表示已选中，如果
                  this.flag = false
                  this.mapTree(this.menuOptions2, checkedKeys[index], checkedKeys)

                  if (this.flag) {
                    serverMenus.push(checkedKeys[index])
                  }
                }
                for (let index = 0; index < checkedKeys.length; index++) {
                  // 服务端菜单便利查找，如果当前层级不存在子级而菜单id存在则表示已选中，如果
                  this.flag = false
                  this.mapTree(this.menuOptions3, checkedKeys[index], checkedKeys)
                  if (this.flag) {
                    pdaMenus.push(checkedKeys[index])
                  }
                }
                this.$refs.serverMenu.setCheckedKeys(serverMenus)
                this.$refs.pdaMenu.setCheckedKeys(pdaMenus)
              })
            }
          } else {
            this.$message.error(msg)
          }
        })
        .catch((err) => {
          this.$message.error(err)
        })
    },
    changePlat(e) {
      this.platform = e
    },

    // 获取选中的菜单节点, 2022-12-06修改
    getCheckedNodes() {
      // this.form.menuIds = [
      //   ...this.$refs.serverMenu.getCheckedKeys(),
      //   ...this.$refs.serverMenu.getHalfCheckedKeys(),
      //   ...this.$refs.pdaMenu.getCheckedKeys(),
      //   ...this.$refs.pdaMenu.getHalfCheckedKeys()
      // ]
      const arr = [
        ...this.$refs.serverMenu.getHalfCheckedKeys(),
        ...this.$refs.pdaMenu.getHalfCheckedKeys(),
        ...this.$refs.pdaMenu.getCheckedKeys(),
        ...this.$refs.serverMenu.getCheckedKeys()
      ]
      this.$set(this.form, 'menuIds', arr)
    },

    // 保存角色
    submit() {
      this.getCheckedNodes(true, true)
      this.$refs.form.validate().then(async (valid) => {
        if (!valid) return false
        this.loading = true
        let res = {}
        this.form.appId = '4'
        if (process.env.VUE_APP_DEPLOYMENT_MODE == 'SAAS') {
          if (this.action === 'new') {
            res = await addRole(this.form)
          } else {
            res = await updateRole(this.form)
          }
        } else if (this.action === 'new') {
          res = await addRolePrivate(this.form)
        } else {
          res = await updateRolePrivate(this.form)
        }

        const { code, msg } = res
        this.loading = false
        if (code === 200) {
          this.$message({
            message: '角色保存成功',
            type: 'success'
          })
          this.close()

          this.$parent.getList()
        } else {
          this.$message.error(msg)
        }
      })
    },
    close() {
      this.$refs.form.resetFields()
      this.form.roleName = ''
      this.platform = '2'
      this.$emit('close')
    },

    // 树权限（展开/折叠）
    handleCheckedTreeExpand(value, type) {
      if (type === '2') {
        const treeList2 = this.menuOptions2
        for (let i = 0; i < treeList2.length; i++) {
          this.$refs.serverMenu.store.nodesMap[treeList2[i].id].expanded = value
        }
      } else {
        const treeList3 = this.menuOptions3
        for (let i = 0; i < treeList3.length; i++) {
          this.$refs.pdaMenu.store.nodesMap[treeList3[i].id].expanded = value
        }
      }
    },
    // 树权限（全选/全不选）
    handleCheckedTreeNodeAll(value, type) {
      if (type === '2') this.$refs.serverMenu.setCheckedNodes(value ? this.menuOptions2 : [])
      else this.$refs.pdaMenu.setCheckedNodes(value ? this.menuOptions3 : [])
    },
    // 树权限（父子联动）
    handleCheckedTreeConnect(value, type) {
      if (type == 'menu') {
        this.menuCheckStrictly = !!value
      } else if (type == 'dept') {
        this.deptCheckStrictly = !!value
      }
    }
  }
}
</script>
